import React, { Component } from 'react';

export class NotFound extends Component {
    render() {
        return (
            <div className="p-3">
                <h1>404 Not found</h1>                
                <p>Sorry, nothing to be found here...</p>
            </div>
        );
    }
}
